// RESPYR JOURNEY PACK JS - Adapté du code FUM

document.addEventListener('DOMContentLoaded', function() {

  // Si on vient de recharger la page suite à un ajout au panier, on rouvre
  // automatiquement le tiroir (état garanti synchronisé, comme un vrai refresh manuel).
  if (sessionStorage.getItem('respyr_open_cart') === '1') {
    sessionStorage.removeItem('respyr_open_cart');
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual';
    }
    window.scrollTo(0, 0);
    setTimeout(function() {
      var cartIcon = document.querySelector('#cart-icon-bubble');
      if (cartIcon) cartIcon.click();
    }, 600);
  }

  var maxPackItems = 3;
  var totalSelectedFlavorCores = 0;
  var activeJourneyPack = 0;
  var selectedDeviceName = null; // ex: "Respyr Aurore"

  document.querySelectorAll('.add-to-cart').forEach(function(item) {
    item.classList.add('js-loaded');
  });

  var jpErrorWrappers = document.querySelectorAll('.rsp-jp-error-warning');
  var jpErrorCounts = document.querySelectorAll('.rsp-jppdp-core-count');

  function changeJPErrorCount(count) {
    jpErrorCounts.forEach(function(el) { el.innerText = count; });
  }

  function changeJPErrorWrapperDisplay(visible) {
    jpErrorWrappers.forEach(function(el) {
      visible ? el.classList.add('show') : el.classList.remove('show');
    });
  }

  var journeyPackEls = document.querySelector('.journey-pack');
  if (!journeyPackEls) return;

  var steps = journeyPackEls.querySelectorAll('div.step');

  function updateActiveJourneyPack() {
    steps.forEach(function(el, idx) {
      var inner = el.querySelector('.step-title');
      if (inner) inner.style.opacity = idx <= activeJourneyPack ? '1' : '0.3';
    });
  }

  steps.forEach(function(item, idx) {
    item.addEventListener('click', function(event) {
      if (event.isTrusted === true) {
        activeJourneyPack = idx;
        updateActiveJourneyPack();
      }
    });
  });

  updateActiveJourneyPack();

  // --- LOGIQUE DE PRIX DYNAMIQUE ---

  function formatPrice(cents) {
    var euros = (cents / 100).toFixed(2).replace('.', ',');
    return euros + ' €';
  }

  var DEVICE_GROUP_MAP = {
    'Respyr Aurore': 'Standard',
    'Respyr Pur': 'Standard',
    'Respyr Duo': 'Duo'
  };

  function findVariant(deviceName, packCount) {
    if (!window.respyrVariants) return null;
    var group = DEVICE_GROUP_MAP[deviceName] || deviceName;
    return window.respyrVariants.find(function(v) {
      return v.inhalateur === group && v.pack === String(packCount);
    }) || null;
  }

  function updateVariantAndPrice() {
    var form = document.querySelector('#product-form-respyr-pack');
    var idInput = form ? form.querySelector('input[name="id"]') : null;

    if (!selectedDeviceName) return;

    var variant = findVariant(selectedDeviceName, maxPackItems);

    if (!variant) {
      document.querySelectorAll('.add-to-cart').forEach(function(b) {
        b.setAttribute('disabled', true);
        b.classList.add('disabled');
      });
      console.error('Respyr: aucune variante trouvée pour', selectedDeviceName, maxPackItems);
      return;
    }

    if (idInput) idInput.value = variant.id;

    var formatted = formatPrice(variant.price);
    document.querySelectorAll('.total-price').forEach(function(el) {
      el.setAttribute('data-price', formatted);
      el.textContent = formatted;
    });
  }

  function updateAddToCartButton() {
    var step1Complete = document.querySelector('.step-1') && document.querySelector('.step-1').classList.contains('complete');
    var step2Complete = document.querySelector('.step-2') && document.querySelector('.step-2').classList.contains('complete');
    var step2Content = document.querySelector('.step-2 .step-content.fum-journeypdp-step-item');
    var step2Open = step2Content && step2Content.getAttribute('aria-expanded') === 'true';

    var atcButtons = document.querySelectorAll('.add-to-cart');
    var buttonText = '';

    if (!step1Complete) {
      buttonText = 'Choisissez votre inhalateur';
      atcButtons.forEach(function(b) { b.setAttribute('disabled', true); b.classList.add('disabled'); });
    } else if (step1Complete && !step2Complete) {
      buttonText = 'Choisissez vos goûts';
      atcButtons.forEach(function(b) { b.setAttribute('disabled', true); b.classList.add('disabled'); });
    } else if (step1Complete && step2Complete) {
      buttonText = 'Ajouter au panier';
      atcButtons.forEach(function(b) {
        b.removeAttribute('disabled');
        b.classList.remove('disabled');
        b.classList.remove('outline');
        b.classList.add('solid');
      });
      updateVariantAndPrice();
    }

    if (step2Open) {
      document.querySelectorAll('.progress-container').forEach(function(p) { p.style.display = 'flex'; });
    }

    atcButtons.forEach(function(b) {
      var span = b.querySelector('span:first-child');
      if (span) span.textContent = buttonText;
    });
  }

  function expandStep(stepNumber) {
    var stepItems = document.querySelectorAll('.step > .step-content.fum-journeypdp-step-item');
    activeJourneyPack = stepNumber - 1;
    updateActiveJourneyPack();
    updateAddToCartButton();
    stepItems.forEach(function(item) {
      var num = parseInt(item.getAttribute('data-step-number'));
      item.setAttribute('aria-expanded', num === stepNumber ? 'true' : 'false');
    });
  }

  function expandStepMultiple(stepNumbers) {
    var stepItems = document.querySelectorAll('.step > .step-content.fum-journeypdp-step-item');
    activeJourneyPack = stepNumbers[0] - 1;
    updateActiveJourneyPack();
    updateAddToCartButton();
    stepItems.forEach(function(item) {
      var num = parseInt(item.getAttribute('data-step-number'));
      item.setAttribute('aria-expanded', stepNumbers.includes(num) ? 'true' : 'false');
    });
  }

  expandStep(1);

  document.querySelectorAll('.step-title').forEach(function(title) {
    title.addEventListener('click', function() {
      var step = this.closest('.step');
      var stepContent = step.querySelector('.step-content.fum-journeypdp-step-item');
      document.querySelectorAll('.step-content.fum-journeypdp-step-item').forEach(function(c) {
        c.setAttribute('aria-expanded', 'false');
      });
      if (stepContent) stepContent.setAttribute('aria-expanded', 'true');
      activeJourneyPack = parseInt(stepContent ? stepContent.getAttribute('data-step-number') : '1') - 1;
      updateActiveJourneyPack();
      updateAddToCartButton();
    });
  });

  function step1Action(btn) {
    document.querySelector('.step-1').classList.add('complete');
    document.querySelectorAll('.step-1 .select-button').forEach(function(b) {
      b.classList.remove('selected');
    });
    btn.classList.add('selected');
    document.querySelectorAll('.step-1 .select-button span:first-child').forEach(function(s) {
      s.textContent = 'Sélectionner';
    });
    btn.querySelector('span:first-child').textContent = 'Sélectionné ✓';

    selectedDeviceName = btn.closest('.device').getAttribute('data-device');

    updateProgressBar();
    updateVariantAndPrice();
    setTimeout(function() {
      changeJPErrorWrapperDisplay(true);
      expandStepMultiple([2]);
    }, 500);
    updateAddToCartButton();
  }

  document.querySelectorAll('.step-1 .select-button').forEach(function(btn) {
    btn.addEventListener('click', function() { step1Action(this); });
  });

  document.querySelectorAll('.step-1 .device img').forEach(function(img) {
    img.addEventListener('click', function() {
      var btn = this.closest('.device').querySelector('.select-button');
      if (btn) btn.click();
    });
  });

  function selectPackSilent(packCount) {
    document.querySelectorAll('.pack-option').forEach(function(p) { p.classList.remove('selected'); });
    var opt = document.querySelector('.pack-option[data-pack="' + packCount + '"]');
    if (opt) {
      opt.classList.add('selected');
      maxPackItems = packCount;
      var maxPackEl = document.querySelector('.max-pack');
      if (maxPackEl) maxPackEl.textContent = maxPackItems;
    }
  }

  function autoSelectPack(total) {
    if (total <= 3) {
      selectPackSilent(3);
    } else if (total <= 6) {
      selectPackSilent(6);
    } else {
      selectPackSilent(11);
    }
  }

  function updateProgressBar() {
    var total = 0;
    document.querySelectorAll('.quantity-selector input').forEach(function(input) {
      total += parseInt(input.value, 10) || 0;
    });

    totalSelectedFlavorCores = total;

    autoSelectPack(total);
    updateVariantAndPrice();

    var selectedPackEl = document.querySelector('.selected-pack');
    if (selectedPackEl) selectedPackEl.textContent = total;

    var percentage = Math.min(total / maxPackItems * 100, 100);
    var progressEl = document.querySelector('.progress');
    if (progressEl) progressEl.style.width = percentage + '%';

    var hardMax = 11;

    if (total >= maxPackItems) {
      document.querySelector('.step-2').classList.add('complete');
    } else {
      document.querySelector('.step-2').classList.remove('complete');
    }

    if (total >= hardMax) {
      document.querySelectorAll('.plus-btn').forEach(function(b) { b.setAttribute('disabled', true); });
      document.querySelectorAll('.flav-select').forEach(function(b) { b.setAttribute('disabled', true); });
    } else {
      document.querySelectorAll('.plus-btn').forEach(function(b) { b.removeAttribute('disabled'); });
      document.querySelectorAll('.flav-select').forEach(function(b) { b.removeAttribute('disabled'); });
    }

    var flavorCountToSelect = maxPackItems - total;
    if (flavorCountToSelect <= 0) {
      flavorCountToSelect = 0;
      changeJPErrorWrapperDisplay(false);
    } else {
      changeJPErrorWrapperDisplay(true);
    }
    changeJPErrorCount(flavorCountToSelect);
    updateAddToCartButton();
  }

  function flavorActionButton(btn) {
    btn.style.display = 'none';
    var quantitySelector = btn.closest('.flavor').querySelector('.quantity-selector');
    if (quantitySelector) {
      quantitySelector.style.display = 'flex';
      var input = quantitySelector.querySelector('input');
      if (input) {
        input.value = 1;
        updateProgressBar();
      }
    }
  }

  document.querySelectorAll('.flav-select').forEach(function(btn) {
    btn.addEventListener('click', function() {
      flavorActionButton(this);
      updateProgressBar();
    });
  });

  document.querySelectorAll('.step-2 .fum-journeypdp-variant-selectable img').forEach(function(img) {
    img.addEventListener('click', function() {
      var btn = this.closest('.flavor').querySelector('.flav-select');
      if (btn) btn.click();
    });
  });

  function clickPackOption(el) {
    document.querySelectorAll('.pack-option').forEach(function(p) { p.classList.remove('selected'); });
    el.classList.add('selected');
    maxPackItems = parseInt(el.getAttribute('data-pack'), 10) || 3;
    var maxPackEl = document.querySelector('.max-pack');
    if (maxPackEl) maxPackEl.textContent = maxPackItems;
    updateProgressBar();
    updateVariantAndPrice();
  }

  document.querySelectorAll('.pack-option').forEach(function(opt) {
    opt.addEventListener('click', function() { clickPackOption(this); });
  });

  function selectDefaultPack(packCount) {
    var opt = document.querySelector('.pack-option[data-pack="' + packCount + '"]');
    if (opt) opt.click();
  }

  document.querySelectorAll('.minus-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var input = this.closest('.quantity-selector').querySelector('input');
      var currentValue = parseInt(input.value);
      if (currentValue > 1) {
        input.value = currentValue - 1;
      } else {
        input.value = 0;
        this.closest('.quantity-selector').style.display = 'none';
        var flavSelect = this.closest('.flavor').querySelector('.flav-select');
        if (flavSelect) flavSelect.style.display = 'block';
      }
      updateProgressBar();
    });
  });

  document.querySelectorAll('.plus-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (totalSelectedFlavorCores < 11) {
        var input = this.closest('.quantity-selector').querySelector('input');
        var currentValue = parseInt(input.value);
        input.value = currentValue + 1;
        updateProgressBar();
      }
    });
  });

  document.querySelectorAll('.add-to-cart').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      updateProgressBar();

      var step1Complete = document.querySelector('.step-1').classList.contains('complete');
      var step2Complete = document.querySelector('.step-2').classList.contains('complete');
      if (!step1Complete || !step2Complete) return;

      updateVariantAndPrice();

      var form = document.querySelector('#product-form-respyr-pack');
      if (!form) return;

      form.querySelectorAll('input[name^="properties"]').forEach(function(i) { i.remove(); });

      var selectedDevice = document.querySelector('.step-1 .select-button.selected');
      if (selectedDevice) {
        var deviceName = selectedDevice.closest('.device').getAttribute('data-device');
        var inp = document.createElement('input');
        inp.type = 'hidden';
        inp.name = 'properties[Inhalateur]';
        inp.value = deviceName;
        form.appendChild(inp);
      }

      var selectedPack = document.querySelector('.pack-option.selected');
      if (selectedPack) {
        var inp2 = document.createElement('input');
        inp2.type = 'hidden';
        inp2.name = 'properties[Pack]';
        inp2.value = selectedPack.getAttribute('data-pack') + ' sachets';
        form.appendChild(inp2);
      }

      var flavorIndex = 1;
      document.querySelectorAll('.flavor').forEach(function(flavor) {
        var quantityInput = flavor.querySelector('input[type="number"]');
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) : 0;
        var flavorName = flavor.getAttribute('data-name');
        if (quantity > 0) {
          var inp3 = document.createElement('input');
          inp3.type = 'hidden';
          inp3.name = 'properties[Goût ' + flavorIndex + ']';
          inp3.value = quantity + 'x ' + flavorName;
          form.appendChild(inp3);
          flavorIndex++;
        }
      });

      if (totalSelectedFlavorCores >= maxPackItems) {
        var formData = new FormData(form);
        btn.setAttribute('disabled', true);
        btn.classList.add('disabled');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        })
          .then(function(response) {
            if (!response.ok) {
              return response.json().then(function(err) {
                throw new Error(err.description || 'Erreur lors de l\'ajout au panier');
              });
            }
            return response.json();
          })
          .then(function() {
            sessionStorage.setItem('respyr_open_cart', '1');
            window.location.reload();
          })
          .catch(function(error) {
            console.error('Respyr: erreur ajout panier', error);
            alert('Une erreur est survenue lors de l\'ajout au panier, merci de réessayer.');
            btn.removeAttribute('disabled');
            btn.classList.remove('disabled');
          });
      }
    });
  });

  document.querySelectorAll('.step-navigator').forEach(function(nav) {
    nav.addEventListener('click', function(e) {
      e.stopPropagation();
      e.preventDefault();
      var step1Complete = document.querySelector('.step-1').classList.contains('complete');
      if (!step1Complete) {
        var t = document.querySelector('.step-1 .step-title');
        if (t) t.click();
      } else {
        var t2 = document.querySelector('.step-2 .step-title');
        if (t2) t2.click();
      }
    });
  });

  document.querySelectorAll('.progress-container').forEach(function(p) { p.style.display = 'none'; });
  document.querySelectorAll('.quantity-selector').forEach(function(q) { q.style.display = 'none'; });

});